<template>
<!--  <div class="demo-image__lazy">-->
<!--    <el-image src="/gis.png" lazy style="margin:0px 0px 0 0px; width:100%;height:700px"></el-image>-->
<!--  </div>-->
  <div style="height: 800px">
<!--    <el-button size="mini" type="primary" @click="fetchWellData">数据刷新</el-button>-->
    <ios-lise ref="iosLise" :is-gis="true" :map-data="isodata" v-on="{refreshData:fetchWellData,imageConfigOk:imageConfigOk}"/>
  </div>
</template>

<script>
import axios from "axios";
// import {ElMessageBox} from "element-plus";
import IosLise from "@/components/iosLise";

export default {
  name: "gisViewer",
  components: {IosLise},
  mounted(){
    this.fetchWellData();
  },
  data() {
    return {
      isodata:{
        mapName:"",
        isoRegions:[],
        isoLines:[],
        faults:[],
        points:[],
        boundary:{
          left:0,
          right:0,
          top:0,
          bottom:0,
          x:0,
          y:0
        },
        blkBoundary:[],
        baseMap:{},
        height:0,
        imageShow:false
      }
    }
  },
  methods: {
    fetchWellData() {
      let blkTypeId = localStorage.getItem("blockType");
      if (blkTypeId == null || blkTypeId==undefined) blkTypeId = "02";
      let checkedBlock = localStorage.getItem("checkedBlock");
      if (checkedBlock == null) {
        checkedBlock = {};
      }
      let jsonCheckedBlk;
      try {
        jsonCheckedBlk = JSON.parse(checkedBlock);
      } catch {
        jsonCheckedBlk = JSON.parse("{}");
      }
      let checkedBlkIdAry = [];
      this.isodata.imageShow = true;
      for (let key in jsonCheckedBlk) {
        checkedBlkIdAry.push(key);
        // if(key == "0AED13F2D11142FFB3A75CBF6B0B1C47")
        //   this.isodata.imageShow = true;
      }
      let _this = this;
      console.log("URL:",process.env.VUE_APP_SERVER)
      axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/gisDataByBlk",//gisWellDataByBlk
        method: 'POST',
        headers: {"Content-Type": "application/json"},
        data: {
          blkType:blkTypeId,
          blkTypeID:blkTypeId,//区块类型银行  1期
          blkIDS:checkedBlkIdAry
        }
      }).then(res => {
        console.log("----------")
        console.log(res)
        console.log("----------")
        if (res.status === 200) {
          _this.isodata.points = res.data.welldata;
          _this.isodata.baseMap = res.data.baseMap
          //_this.isodata.baseMap.src = "http://127.0.0.1:9610/cgi-bin/mapserv.exe?map=../../apps/tlmMap/xj.map&MODE=map&LAYERS=xj_region+tif&MAPSIZE=1000%20600&MAPEXT=90%2020%2095%2050";
          _this.isodata.blkBoundary = res.data.blkBoundary
          // if(!_this.isodata.imageShow)
          {
            _this.isodata.boundary = res.data.boundary;
            console.log("-------------------------------------",res.data)
            //this.$refs.container.$el.offsetWidth
            let w = this.$refs.iosLise.$el.offsetWidth;
            w*=0.916666666667
            w-=200;
            let h = this.$refs.iosLise.$el.offsetParent.offsetHeight;
            h-=45;
            h-=48;
            h-=28;
            console.log("这里是wh",w,h)
            let dataBottom = this.isodata.boundary.bottom;
            let dataTop = this.isodata.boundary.top;
            let dataLeft = this.isodata.boundary.left;
            let dataRight = this.isodata.boundary.right;
            let ch = dataTop;
            ch -= dataBottom;
            console.log("dataHeight",ch)
            let cw = dataRight;
            cw -= dataLeft;
            console.log("dataWidth",cw)
            let aspectRatio = w;
            aspectRatio/=h;
            console.log("w/h",aspectRatio)
            console.log("=============")
            console.log(ch,cw)
            if(aspectRatio<cw/ch){
              console.log("走的这里啦")
              console.log(aspectRatio)
              console.log("ch",ch)
              console.log("cw",cw)
              let y = cw;
              y /= aspectRatio;
              y-= ch;
              y/=2;
              _this.isodata.boundary.top+=y;
              _this.isodata.boundary.bottom-=y;
              _this.isodata.boundary.x = 0;
              _this.isodata.boundary.y = y;
              console.log("isodataCalcEnd:",_this.isodata);
            }else
            {
              console.log("还是这里呢")
              console.log(aspectRatio)
              console.log("ch",ch)
              console.log("cw",cw)
              let x = ch;
              x*=aspectRatio;
              x-= cw;
              x/=2;
              _this.isodata.boundary.left-=x;
              _this.isodata.boundary.right+=x;
              _this.isodata.boundary.x = x;
              _this.isodata.boundary.y = 0;
              console.log()
            }
          }
          // else{
          //   console.log(111111111,res.data.boundary)
          //   // _this.isodata.boundary.left = 4593000;
          //   // _this.isodata.boundary.right = 4596000;
          //   // _this.isodata.boundary.top = 14679000;
          //   // _this.isodata.boundary.bottom = 14675000;
          //   // _this.isodata.boundary.bottom = 4593000;
          //   // _this.isodata.boundary.top = 4596000;
          //   _this.isodata.boundary.bottom = -4596610.500185;
          //   _this.isodata.boundary.top = -4592577.149962;
          //   _this.isodata.boundary.right = 14679969.60941;
          //   _this.isodata.boundary.left = 14674808.883895;
          // }
          console.log("iso:",res.data);
          console.log("---------------------------------");
          console.log(this.$refs.iosLise);
          console.log(this.$refs.iosLise.$el.offsetParent.offsetHeight);
          this.isodata.height=this.$refs.iosLise.$el.offsetParent.offsetHeight
          this.$refs.iosLise.getData();
        }

      }).catch(err => {
        // ElMessageBox('Error');
        console.log(err)
      })
    },
    imageConfigOk(){
      this.fetchWellData();
    },
  },

}
</script>